import { X } from "lucide-react";
import { type ReactNode, useId } from "react";
import { createPortal } from "react-dom";
import { useDialogLifecycle } from "../dialog";

interface ModalProps {
  open: boolean;
  title: string;
  description?: string;
  width?: "small" | "medium" | "large";
  children: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
  busy?: boolean;
}
export function Modal({ open, title, description, width = "medium", children, footer, onClose, busy = false }: ModalProps) {
  const id = useId();
  const ref = useDialogLifecycle(open, onClose, busy);
  if (!open) return null;
  return createPortal(<div className="modal-backdrop" role="presentation" onMouseDown={(event) => { if (!busy && event.target === event.currentTarget) onClose(); }}>
    <section ref={ref} tabIndex={-1} className={`modal modal-${width}`} role="dialog" aria-modal="true" aria-labelledby={`${id}-title`} aria-describedby={description ? `${id}-description` : undefined} aria-busy={busy}>
      <header className="modal-header"><div><h2 id={`${id}-title`}>{title}</h2>{description && <p id={`${id}-description`}>{description}</p>}</div>
        <button className="icon-button modal-close-button" type="button" disabled={busy} onClick={onClose} title={busy ? "正在提交，请勿重复操作" : "关闭"} aria-label="关闭弹窗"><X size={18} /></button>
      </header>
      <div className="modal-body">{children}</div>
      {footer && <footer className="modal-footer">{footer}</footer>}
    </section>
  </div>, document.body);
}
